import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import wrapLegacyRoute from 'router/legacy/wrapLegacyRoute';
import translation from 'translation';

const projectCrossMinusRoutes = [
  {
    path: 'crossminus',
    component: NestedRouteComponent,
    meta: {
      routeName: {
        segmentName: () => translation.tr('Crossminusing')
      },
      permissions: ['READ_CROSSMINUS']
    },
    children: [
      {
        path: '',
        name: 'crossminus',
        component: wrapLegacyRoute('toolsController', 'crossminus')
      },
      {
        path: 'results',
        name: 'crossminusResults',
        component: wrapLegacyRoute('toolsController', 'crossminusResults')
      }
    ]
  }
];

export default projectCrossMinusRoutes;
